import { BaseService } from '#services/BaseService';
import { http } from '#utils/axios';

class TraderService extends BaseService {
  getTraderInfo = async (id) => {
    const { data } = await http({
      url: `${this.endpoint}/${id}`
    });
    return data;
  };

  getOptionsList = (params) => {
    return http({
      params,
      url: `${this.endpoint}/`
    }).then(({ data }) => ({
      next: data.next,
      result: data.result?.map((el) => {
        return {
          label: el.name,
          value: el.id
        };
      })
    }));
  };

  updateProfile = async (id, data) => {
    const { data: result } = await http({
      data,
      method: 'PATCH',
      url: `${this.endpoint}/${id}`
    });
    return result;
  };

  changeBalance = async (id, data) => {
    const { data: result } = await http({
      data,
      method: 'PATCH',
      url: `${this.endpoint}/${id}/change-balance`
    });
    return result;
  };

  getTraderProfileTransactions = async (params) => {
    const { data } = await http({
      method: 'GET',
      params,
      url: `/trader-profile-transactions`
    });

    return data;
  };

  constructor() {
    super('/trader-profile');
    if (!TraderService.instance) {
      TraderService.instance = this;
    }
    return TraderService.instance;
  }
}

const instance = new TraderService();
Object.freeze(instance);

export default instance;
